import { ImageModalPageModule } from './../pages/image-modal/image-modal.module';
import { MenuPageModule } from './../pages/menu/menu.module';
import { LoginPageModule } from './../pages/login/login.module';
import { MatchDetailsHeaderComponentModule } from './../components/match-details-header/match-details-header.module';
import { ChatInputComponentModule } from './../components/chat-input/chat-input.module';
import { ChatComponentModule } from './../components/chat/chat.module';
import { NgModule, ErrorHandler, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { MyApp } from './app.component';

import { MenuPage } from '../pages/menu/menu';
import { PopoverPage } from '../pages/leader-board/popover';
import { MatchPopoverPage } from '../pages/match/popover';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { WebSocketService } from '../services/webSocketService';
import { RestService } from '../services/restService';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LocalStorageModule } from 'angular-2-local-storage';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UserManagerProvider } from '../providers/user-manager/user-manager';
import { GalleryModal } from 'ionic-gallery-modal';
import { ZoomableImage } from 'ionic-gallery-modal';
import { CustomStorageProvider } from '../providers/custom-storage/custom-storage';
import { HorseRaceDataProvider } from '../providers/horse/horse-race-data/horse-race-data';
import { HorseBetDataProvider } from '../providers/horse/horse-bet-data/horse-bet-data';
import { HorseDataConverterProvider } from '../providers/horse/horse-data-converter/horse-data-converter';
import { SubscribePopoverPage } from '../pages/leader-board/subscribe-popover';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2';
import { CloudSettings, CloudModule } from '@ionic/cloud-angular';
import { Push } from '@ionic-native/push';
import { Device } from '@ionic-native/device';
import { SocialSharing } from '@ionic-native/social-sharing';
import { Camera } from '@ionic-native/camera';
import { Constants } from '../util/Constants';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AdBannerProvider } from '../providers/ad-banner/ad-banner';
import { AppVersion } from '@ionic-native/app-version';
import { ThemeableBrowser} from '@ionic-native/themeable-browser';
import { BrowserTab } from '@ionic-native/browser-tab';
import { TutorialProvider } from '../providers/tutorial/tutorial';
import { ListTipsPopoverPage } from '../pages/horse/horse-home-list-tips/filter';
import { LoadingCtrlProvider } from '../providers/loading-ctrl/loading-ctrl';
// import { BackgroundMode } from '@ionic-native/background-mode';
import { AppAvailability } from '@ionic-native/app-availability';
import { Market } from '@ionic-native/market';
import { YoutubeVideoPlayer } from '@ionic-native/youtube-video-player';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { AdMobFree } from '@ionic-native/admob-free';
import { KintipsInAppPurchaseProvider } from '../providers/kintips-in-app-purchase/kintips-in-app-purchase';
import { ResponsiveProvider } from '../providers/responsive/responsive';


const cloudSettings: CloudSettings = {
  'core': {
    'app_id': Constants.IONIC_APP_ID
  }
};

declare var window;

export class IonicErrorMonitoringErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    window.Ionic.handleNewError(err);
  }
}

@NgModule({
  declarations: [
    MyApp,
    PopoverPage,
    MatchPopoverPage,
    ListTipsPopoverPage,
    SubscribePopoverPage,
    GalleryModal,
    ZoomableImage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      tabsHideOnSubPages: true,
      backButtonText: '',
      pageTransition: "md-transition",
      backButtonIcon: "md-arrow-back",
      pageTransitionDelay: 0
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    }),
    LocalStorageModule.withConfig({
      prefix: 'ls.', // this matches the prefix with Kintips such that the values can be shared
      storageType: 'localStorage'
    }),
    CloudModule.forRoot(cloudSettings),
	  FormsModule,
	  HttpModule,
    ChatComponentModule,
    ChatInputComponentModule,
    MatchDetailsHeaderComponentModule,
    LoginPageModule,
    ImageModalPageModule,
    MenuPageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    PopoverPage,
    MatchPopoverPage,
    ListTipsPopoverPage,
    SubscribePopoverPage,
  MenuPage,
    GalleryModal,
  ],
  providers: [
    StatusBar,
    SplashScreen,
	  WebSocketService,
	  RestService,
    //{provide: ErrorHandler, useClass: IonicErrorMonitoringErrorHandler},
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    UserManagerProvider,
    CustomStorageProvider,
    HorseRaceDataProvider,
    HorseBetDataProvider,
    HorseDataConverterProvider,
    InAppPurchase2,
    Push,
    Device,
    SocialSharing,
    Camera,
    InAppBrowser,
    AdBannerProvider,
    AppVersion,
    ThemeableBrowser,
    BrowserTab,
    TutorialProvider,
    LoadingCtrlProvider,
    // BackgroundMode,
    AppAvailability,
    File,
    FileOpener,
    AdMobFree,
    Market,
    YoutubeVideoPlayer,
    KintipsInAppPurchaseProvider,
    ResponsiveProvider
  ],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule {}

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/languages/', '.json?v=' + Constants.VERSION);
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts